import React, { useEffect } from "react";
import { useCountryStore } from "../../store/countryStore.js";
import { Link, useLocation } from "react-router-dom";
import dayjs from "dayjs";
import { Select, DatePicker, Input, Popover } from "antd";


import images from "../../assets";

import PrimaryButton from "../button/primarybutton";

export default function AdvancedFilter(props) {
  const location = useLocation();
  const { countries, states, getStates } = useCountryStore();

  useEffect(() => {
    const payload = { country: [props?.filters.country] };
    getStates(payload);
  }, [getStates, props?.filters.country]);

  const dropdownOptions = [
    {
      value: "pending",
      label: "Pending",
    },
    {
      value: "approved",
      label: "Approved",
    },
    {
      value: "rejected",
      label: "Rejected",
    },
  ];

  return (
    <div className="flex flex-col">
      <div className="h-14 px-6 py-3 bg-white rounded-tl-2xl rounded-tr-2xl justify-between items-center inline-flex">
        <div className="text-[#222222] text-2xl font-semibold  leading-loose">
          Advanced Filter
        </div>
        <div className="w-8 h-8 justify-center items-center flex">
          <div className="w-8 h-8 justify-center items-center inline-flex">
            <div className="w-8 h-8 relative">
              <img
                className="cursor-pointer"
                onClick={() => props?.onClick()}
                src={images.crossSquire}
                alt="close"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-7 p-6 bg-white">
        <div className="flex flex-row gap-7 items-center justify-between">
          <div className="flex-col justify-start items-start gap-2 flex">
            <p>Select Gender:</p>
            <Select
              allowClear
              showSearch
              style={{
                width: 160,
                height: 48,
              }}
              placeholder="Please Select"
              options={[
                {
                  value: "male",
                  label: "Male",
                },
                {
                  value: "female",
                  label: "Female",
                },
              ]}
              onChange={(e) =>
                props?.setFilters({ ...props?.filters, gender: e })
              }
              value={props?.filters.gender || undefined}
            />
          </div>
          <div className="w-full flex-col justify-start items-start gap-2 flex">
            <p>Enter Keyword:</p>
            <Input
              style={{ height: 48 }}
              placeholder="Filled"
              onChange={(e) =>
                props?.setFilters({
                  ...props?.filters,
                  keyword: e.target.value,
                })
              }
              value={props?.filters.keyword}
            />
          </div>
          <div className="flex-col justify-start items-start gap-2 flex">
            <p>Plan Type:</p>
            <Select
              allowClear
              showSearch
              style={{
                width: 160,
                height: 48,
              }}
              placeholder="Please Select"
              options={[
                {
                  value: "standard",
                  label: "Standard",
                },
                {
                  value: "premium",
                  label: "Premium",
                },
              ]}
              onChange={(e) =>
                props?.setFilters({ ...props?.filters, planType: e })
              }
              value={props?.filters.planType || undefined}
            />
          </div>
          <div className="flex-col justify-start items-start gap-2 flex">
            <p>Select Date:</p>
            <DatePicker
              style={{
                width: 160,
                height: 48,
              }}
              onChange={(date, dateString) =>
                props?.setFilters({ ...props?.filters, date: dateString })
              }
              value={
                props?.filters?.date
                  ? dayjs(props?.filters?.date, "YYYY-MM-DD")
                  : null
              }
            />
          </div>
        </div>
        <div className="w-full flex flex-row gap-7 items-center">
          <div className="w-full flex-col justify-start items-start gap-2 flex">
            <p>Photo Status</p>
            <Select
              allowClear
              showSearch
              style={{
                width: "100%",
                height: 48,
              }}
              placeholder="Please Select"
              options={dropdownOptions}
              onChange={(e) =>
                props?.setFilters({ ...props?.filters, photoStatus: e })
              }
              value={props?.filters.photoStatus || undefined}
            />
          </div>
          <div className="w-full flex-col justify-start items-start gap-2 flex">
            <p>Profile Description Status</p>
            <Select
              allowClear
              showSearch
              style={{
                width: "100%",
                height: 48,
              }}
              placeholder="Please Select"
              options={dropdownOptions}
              onChange={(e) =>
                props?.setFilters({ ...props?.filters, profileDescStatus: e })
              }
              value={props?.filters.profileDescStatus || undefined}
            />
          </div>
          <div className="w-full flex-col justify-start items-start gap-2 flex">
            <p>Match Description Status</p>
            <Select
              allowClear
              showSearch
              style={{
                width: "100%",
                height: 48,
              }}
              placeholder="Please Select"
              options={dropdownOptions}
              onChange={(e) =>
                props?.setFilters({ ...props?.filters, matchDescStatus: e })
              }
              value={props?.filters.matchDescStatus || undefined}
            />
          </div>
          <div className="w-full flex-col justify-start items-start gap-2 flex">
            <p>Documents Status</p>
            <Select
              allowClear
              showSearch
              style={{
                width: "100%",
                height: 48,
              }}
              placeholder="Please Select"
              options={dropdownOptions}
              onChange={(e) =>
                props?.setFilters({ ...props?.filters, documentStatus: e })
              }
              value={props?.filters.documentStatus || undefined}
            />
          </div>
          <div className="w-full flex-col justify-start items-start gap-2 flex">
            <p>Country Status</p>
            <Select
              allowClear
              showSearch
              style={{
                width: "100%",
                height: 48,
              }}
              placeholder="Please Select"
              options={dropdownOptions}
              onChange={(e) =>
                props?.setFilters({ ...props?.filters, countryStatus: e })
              }
              value={props?.filters.countryStatus || undefined}
            />
          </div>
        </div>
        <div className="flex flex-row gap-7 items-center">
          <div className="flex-col justify-start items-start gap-2 flex">
            <p>DOB Status</p>
            <Select
              allowClear
              showSearch
              style={{
                width: 200,
                height: 48,
              }}
              placeholder="Please Select"
              options={dropdownOptions}
              onChange={(e) =>
                props?.setFilters({ ...props?.filters, dateOfBirthStatus: e })
              }
              value={props?.filters.dateOfBirthStatus || undefined}
            />
          </div>
          <div className="flex-col justify-start items-start gap-2 flex">
            <p>Gender Status</p>
            <Select
              allowClear
              showSearch
              style={{
                width: 200,
                height: 48,
              }}
              placeholder="Please Select"
              options={dropdownOptions}
              onChange={(e) =>
                props?.setFilters({ ...props?.filters, genderStatus: e })
              }
              value={props?.filters.genderStatus || undefined}
            />
          </div>
        </div>
        <div className="flex flex-row gap-7 items-center">
          <div className="flex-col justify-start items-start gap-2 flex">
            <p>Age:</p>
            <div className="flex flex-row gap-2 items-center">
              <Select
                allowClear
                showSearch
                style={{
                  width: 80,
                  height: 48,
                }}
                placeholder="Select"
                options={Array.from({ length: 83 }, (_, i) => {
                  const age = 18 + i;
                  return {
                    value: age,
                    label: age.toString(),
                  };
                })}
                onChange={(value) =>
                  props?.setFilters({
                    ...props?.filters,
                    ageMin: value,
                    ageMax: Math.max(props?.filters?.ageMax, value + 1),
                  })
                }
                value={props?.filters.ageMin || undefined}
              />
              <p>to</p>
              <Select
                allowClear
                showSearch
                style={{
                  width: 80,
                  height: 48,
                }}
                placeholder="Select"
                options={Array.from({ length: 83 }, (_, i) => {
                  const age = 18 + i;
                  if (age > props?.filters?.ageMin) {
                    return {
                      value: age,
                      label: age.toString(),
                    };
                  }
                  return null;
                }).filter(Boolean)}
                onChange={(value) => {
                  props?.setFilters({
                    ...props?.filters,
                    ageMax: value,
                    ageMin: Math.min(props?.filters?.ageMin, value - 1),
                  });
                }}
                value={props?.filters.ageMax || undefined}
              />
            </div>
          </div>
          <div className="flex-col justify-start items-start gap-2 flex">
            <p>Profile Completeness:</p>
            <div className="flex flex-row gap-2 items-center">
              <Input
                style={{
                  width: 80,
                  height: 48,
                }}
                placeholder="10"
                onChange={(e) =>
                  props?.setFilters({
                    ...props?.filters,
                    profileCompletenessMin: e.target.value,
                  })
                }
                value={props?.filters.profileCompletenessMin}
              />
              <p>to</p>
              <Input
                style={{
                  width: 80,
                  height: 48,
                }}
                placeholder="90"
                onChange={(e) =>
                  props?.setFilters({
                    ...props?.filters,
                    profileCompletenessMax: e.target.value,
                  })
                }
                value={props?.filters.profileCompletenessMax}
              />
            </div>
          </div>
          <div className="flex-col justify-start items-start gap-2 flex">
            <p>Marital Status:</p>
            <Select
              allowClear
              showSearch
              // mode="multiple"
              style={{
                width: 360,
                height: 48,
              }}
              placeholder="Please Select"
              options={[
                { label: "Never married", value: "neverMarried" },
                { label: "Married", value: "married" },
                { label: "Divorced", value: "divorced" },
                { label: "Widowed", value: "widowed" },
              ]}
              onChange={(e) =>
                props?.setFilters({
                  ...props?.filters,
                  maritalStatus: e,
                })
              }
              value={props?.filters.maritalStatus}
            />
          </div>
        </div>
        {location?.pathname === "/user-management/userList/" && (
          <div className="flex flex-row gap-7 items-center">
            <div className="flex-col justify-start items-start gap-2 flex">
              <p>Status:</p>
              <Select
                allowClear
                showSearch
                // mode="multiple"
                style={{
                  width: 340,
                  height: 48,
                }}
                placeholder="Please Select"
                options={[
                  {
                    value: "active",
                    label: "Active",
                  },
                  {
                    value: "suspended",
                    label: "Suspended",
                  },
                  {
                    value: "blocked",
                    label: "Blocked",
                  },
                  {
                    value: "deactivate",
                    label: "Deactivated",
                  },
                  {
                    value: "delete",
                    label: "Deleted",
                  },
                ]}
                onChange={(e) =>
                  props?.setFilters({
                    ...props?.filters,
                    status: e,
                  })
                }
                value={props?.filters?.status}
              />
            </div>
          </div>
        )}
        <div className="flex flex-row gap-7 items-center">
          <div className="flex-col justify-start items-start gap-2 flex">
            <p>Country:</p>
            <Select
              allowClear
              className="adv-country"
              showSearch
              // mode="multiple"
              style={{
                width: 360,
                minHeight: "48px",
              }}
              placeholder="Please Select"
              options={countries?.map((country) => ({
                label: country?.name,
                value: country.name,
              }))}
              onChange={(e) =>
                props?.setFilters({
                  ...props?.filters,
                  country: e,
                })
              }
              value={props?.filters.country}
            />
          </div>
          <div className="flex-col justify-start items-start gap-2 flex">
            <p>State:</p>
            <Select
              allowClear
              className="adv-country"
              showSearch
              // mode="multiple"
              style={{
                width: 360,
                minHeight: "48px",
              }}
              placeholder="Please Select"
              options={states?.map((state) => ({
                label: state?.name,
                value: state.name,
              }))}
              onChange={(e) =>
                props?.setFilters({
                  ...props?.filters,
                  stateProvince: e,
                })
              }
              value={props?.filters.stateProvince}
            />
          </div>
          <div className="flex-col justify-start items-start gap-2 flex">
            <p>Registration Source:</p>
            <Select
              allowClear
              showSearch
              // mode="multiple"
              style={{
                width: 360,
                height: 48,
              }}
              placeholder="Please Select"
              options={[
                {
                  value: "web",
                  label: "Web",
                },
                {
                  value: "android",
                  label: "Android",
                },
                {
                  value: "ios",
                  label: "iOS",
                },
              ]}
              onChange={(e) =>
                props?.setFilters({
                  ...props?.filters,
                  regSource: e,
                })
              }
              value={props?.filters.regSource}
            />
          </div>
        </div>
      </div>
      <div className="h-24 px-4 py-6 bg-primary50 rounded-bl-2xl rounded-br-2xl flex-col justify-center items-end gap-2.5 inline-flex">
        <div className="w-full self-stretch justify-between items-center flex export-adv-dropdown">
          <Popover
            placement="top"
            content={
              <div className="flex flex-col gap-2 w-[150px]">
                <Link to="#">Export as .CSV</Link>
                <Link to="#">Export as .XLX</Link>
                <Link to="#">Export as .PDF</Link>
              </div>
            }
            trigger="click"
          >
            <PrimaryButton
              style={{
                width: "150px",
                height: "48px",
                fontSize: "14px",
              }}
              text={"Export"}
              iconalign="left"
              icon={images.downArrowWhite}
            />
          </Popover>
          <div className="justify-start items-center gap-[25px] flex">
            <PrimaryButton
              style={{
                width: "160px",
                height: "48px",
                fontSize: "14px",
              }}
              text={"Search"}
              iconalign="left"
              icon={images.searchWhiteIcon}
              onClick={props?.handleSearch}
            />
            <PrimaryButton
              style={{
                width: "160px",
                height: "48px",
                fontSize: "14px",
                background: "#F4F4F5",
                color: "Black",

                border: "2px solid #D4D4D8",
              }}
              text={"Reset"}
              onClick={props?.handleReset}
            />
          </div>
        </div>
      </div>
    </div>
  );
}








